import { useId } from "react";
import styles from "./TextField.module.css";

export default function TextField({ label, ...inputProps }) {
  const id = useId();

  return (
    <div className={styles.field}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <input id={id} className={styles.input} {...inputProps} />
    </div>
  );
}
